const randomize = (from, to) => {
	const arr = [];
	for(let i=from; i<=to; i++)
		arr.push(i);
	const narr = [];
	while(arr.length) {
		narr.push(arr.splice(Math.floor(Math.random()*arr.length), 1)[0])
	}
	return narr;
}
export const isFill = arr => {
	for(let i of arr)
		for(let j of i)
			if(j.num===null|| j.red) return false;
	return true;
}

const applyPrimaryChances = (arr) => {
	if(isFill(arr)) return arr;
	for(let i=0; i<9; i++) {
		for(let j=0; j<9; j++) {
			if(arr[i][j].chances?.length===1) {
				arr[i][j].num = arr[i][j].chances[0];
				arr[i][j].chances = null;
				clearFromChance(arr, i, j);
				return applyPrimaryChances(arr)
			}
		}
	}
	return applySecondaryChances(arr);
}
const applySecondaryChances = (arr) => {
	if(isFill(arr)) return arr;
	for(let i=0; i<9; i++) {
		let chances = [];
		for(let j=0; j<9; j++) {
			if(arr[i][j].chances?.length) {
				for(let k of arr[i][j].chances) {
					if(!chances[k-1]) chances[k-1] = [j];
					else chances[k-1].push(j)
				}
			}
		}
		for(let k=1; k<10; k++) {
			if(chances[k-1]?.length===1) {
				arr[i][chances[k-1]].num = k;
				arr[i][chances[k-1]].chances = null;
				clearFromChance(arr, i, chances[k-1]);
				return applyPrimaryChances(arr);
			}
		}
	}
	for(let j=0; j<9; j++) {
		let chances = [];
		for(let i=0; i<9; i++) {
			if(arr[i][j].chances?.length) {
				for(let k of arr[i][j].chances) {
					if(!chances[k-1]) chances[k-1] = [i];
					else chances[k-1].push(i)
				}
			}
		}
		for(let k=1; k<10; k++) {
			if(chances[k-1]?.length===1) {
				arr[chances[k-1]][j].num = k;
				arr[chances[k-1]][j].chances = null;
				clearFromChance(arr, chances[k-1], j);
				return applyPrimaryChances(arr);
			}
		}
	}
	for(let a=0; a<9; a++) {
		let chances = [];
		for(let b=0; b<9; b++) {
			const i = (a%3)*3 + b%3, j = Math.floor(a/3)*3 + Math.floor(b/3);
			if(arr[i][j].chances?.length) {
				for(let k of arr[i][j].chances) {
					if(!chances[k-1]) chances[k-1] = [b];
					else chances[k-1].push(b)
				}
			}
		}
		for(let k=1; k<10; k++) {
			if(chances[k-1]?.length===1) {
				const i = (a%3)*3 + chances[k-1]%3, j = Math.floor(a/3)*3 + Math.floor(chances[k-1]/3);
				arr[i][j].num = k;
				arr[i][j].chances = null;
				clearFromChance(arr, i, j);
				return applyPrimaryChances(arr);
			}
		}
	}
	return arr;
}

const clearFromChance = (arr, x, y) => {
	for(let i=0; i<9; i++) {
		if(arr[i][y].chances)
			arr[i][y].chances = arr[i][y].chances.filter(k => k!==arr[x][y].num)
		else if(i!==x && arr[i][y].num===arr[x][y].num) {
			arr[x][y].red = arr[i][y].red = true;
			throw new Error('crashed');
		}
	}
	for(let j=0; j<9; j++) {
		if(arr[x][j].chances)
			arr[x][j].chances = arr[x][j].chances.filter(k => k!==arr[x][y].num)
		else if(j!==y && arr[x][j].num===arr[x][y].num) {
			arr[x][j].red = arr[x][y].red = true;
			throw new Error('crashed');
		}
	}

	const a = Math.floor(x/3) + Math.floor(y/3)*3;
	for(let b=0; b<9; b++) {
		const i = (a%3)*3 + b%3, j = Math.floor(a/3)*3 + Math.floor(b/3);
		if(arr[i][j].chances)
			arr[i][j].chances = arr[i][j].chances.filter(k => k!==arr[x][y].num)
		else if((x!==i || y!==j) && arr[x][y].num===arr[i][j].num) {
			arr[x][y].red = arr[i][j].red = true;
			throw new Error('crashed');
		}
	}

	for(let i=0; i<9; i++) {
		for(let j=0; j<9; j++) {
			if(!arr[i][j].chances?.length && !arr[i][j].num)
				throw new Error('crashed');
		}
	}
}

const makeChances = (garr, x, y, num, allowErr) => {
	const oneOfs = [];
	const arr = [...garr];
	for(let i=0; i<9; i++) {
		arr[i] = [...arr[i]];
		for(let j=0; j<9; j++) {
			arr[i][j] = {...arr[i][j], red: false};
			if(i===x && j===y)
				arr[i][j].num = num;
			if(!arr[i][j].num)
				arr[i][j].chances = [1,2,3,4,5,6,7,8,9];
			else
				delete arr[i][j].chances;
		}
	}
	try {
		for(let i=0; i<9; i++) {
			for(let j=0; j<9; j++) {
				if(arr[i][j].num)
					clearFromChance(arr, i, j)
			}
		}
		const narr = [...arr];
		for(let i=0; i<9; i++) {
			narr[i] = [...narr[i]];
			for(let j=0; j<9; j++) {
				narr[i][j] = {...narr[i][j]};
				if(narr[i][j].chances)
					narr[i][j].chances = [...narr[i][j].chances];
			}
		}
		return applyPrimaryChances(narr);
	} catch (error) {
		if(error.message==="crashed" && allowErr)
			return arr;
		throw error;
	}
}

const countFilled = (arr) => {
	let tot = 0;
	for(let i of arr)
		for(let j of i)
			if(j.num!==null) tot ++;
	return tot;
}
const print = arr => {
	return console.log(arr.map(i => i.map(j => j.num || ' ').join(' ')).join('\n'))
}

const autoFill = (arr, startTime=Date.now()) => {
	if(Date.now()-startTime > 2000)
		throw new Error('repeat');
	const iorder = randomize(0,8);
	const jorder = randomize(0,8);
	const norder = randomize(1,9);
	try {
	for(let kk=0; kk<norder.length; kk++) {
		try {
			for(let ii=0; ii<iorder.length; ii++) {
				try {
					for(let jj=0; jj<jorder.length; jj++) {
						try {
							// console.log('starting', [...ids, (kk*9+ii)*9+jj].join(' > '), countFilled(arr))
							if(!(arr[iorder[ii]][jorder[jj]].chances?.indexOf(norder[kk])>=-1))
								continue;
							let newarr = makeChances(arr, iorder[ii], jorder[jj], norder[kk]);
							if(isFill(newarr))
								return newarr;
							//print(arr);
							//console.log('again', ii, jj, kk, countFilled(newarr));
							//print(newarr);
							//console.log('--');
							return autoFill(newarr, startTime);
						} catch (error) {
							// console.log('back 0', countFilled(arr), error.message);
							if(error.message!=="crashed" || jj===8) throw error;
						}
					}
				} catch (error) {
					// console.log('back 1', countFilled(arr), error.message);
					if(error.message!=="crashed" || ii===8) throw error;
				}
			}
		} catch (error) {
			// console.log('back 2', countFilled(arr), error.message);
			if(error.message!=="crashed" || kk===9) throw error;
		}
	}
	throw new Error('crashed');
	} catch (error) {
		throw error;
	}
}

const counts = [
	[3,4,3,4,3,4,3,4,3],
	[4,5,6,5,4,6,5,6,4],
	[4,5,6,7,4,5,6,7,8],
];

const filterout = (arr, level) => {
	for(let i of arr) {
		for(let j of i) {
			j.fixed = true;
		}
	}
	const boxOrder = randomize(0,8)
	for(let a=0; a<9; a++) {
		const cells = randomize(0,8);
		for(let b=0; b<counts[level][boxOrder[a]]; b++) {
			const i = (a%3)*3+cells[b]%3,
				j = Math.floor(a/3)*3+Math.floor(cells[b]/3);
			arr[i][j].num = null;
			arr[i][j].fixed = false;
		}
	}
	return arr;
}

const makeSudokuStruct = async(level) => {
	const rand = 'boards/'+Math.floor(Math.random()*3000)
	const res = await fetch(rand)
	if(res.status===200) {
		const txt = await res.text();
		const arr = txt.split(' ').map(i => i.split('').map(j => ({num: Number(j)})));
		return filterout(arr, level==='hard'?2:level==='medium'?1:0);
	}
	const arr = [];
	for(let i=0; i<9; i++) {
		const c = [];
		for(let i=0; i<9; i++) {
			c.push({num: null});
		}
		arr.push(c);
	}
	try {
		return filterout(autoFill(makeChances(arr, 0, 0, null)), level==='hard'?2:level==='medium'?1:0);
	} catch (error) {
		console.log(error.message);
		if(error.message==="repeat")
			return makeSudokuStruct()
	}
}

export const mark = (arr, x, y, num) => {
	const narr = [...arr];
	for(let i=0; i<9; i++) {
		narr[i] = [...narr[i]];
		for(let j=0; j<9; j++) {
			narr[i][j] = {...narr[i][j], red: false};
			if(i===x && j===y) {
				narr[i][j].num = num;
			}
		}
	}
	for(let i=0; i<9; i++) {
		const inds = [null, null, null, null, null, null, null, null, null];
		for(let j=0; j<9; j++) {
			const num = narr[i][j].num;
			if(num) {
				if(inds[num-1]!==null) {
					narr[i][j].red = true;
					narr[i][inds[num-1]].red = true;
				} else
					inds[num-1] = j;
			}
		}
	}
	for(let j=0; j<9; j++) {
		const inds = [null, null, null, null, null, null, null, null, null];
		for(let i=0; i<9; i++) {
			const num = narr[i][j].num;
			if(num) {
				if(inds[num-1]!==null) {
					narr[i][j].red = true;
					narr[inds[num-1]][j].red = true;
				} else
					inds[num-1] = i;
			}
		}
	}
	for(let a=0; a<9; a++) {
		const inds = [null, null, null, null, null, null, null, null, null];
		for(let b=0; b<9; b++) {
			const i = (a%3)*3+b%3,
				j = Math.floor(a/3)*3+Math.floor(b/3);
			const num = narr[i][j].num;
			if(num) {
				if(inds[num-1]!==null) {
					narr[i][j].red = true;
					const nb = inds[num-1];
					const ni = (a%3)*3+nb%3,
						nj = Math.floor(a/3)*3+Math.floor(nb/3);
					narr[ni][nj].red = true;
				} else
					inds[num-1] = b;
			}
		}
	}
	return narr;
}

export default makeSudokuStruct;
